<!--
    描述： 实时上传组件 封装
    创建时间： 2022-03-28 16:07:19
    作者： Wang Shuai
    邮箱： 591372242@qq.com
-->
<template>
  <div
    class="file-container"
    v-loading="uploadLoading"
    ref="fileContainer"
    :class="{ 'list-upload': listType === 'text' }"
  >
    <!-- 正常编辑模式 -->
    <template v-if="!isViewMode">
      <!-- 图片模式 -->
      <template v-if="listType === 'picture-card'">
        <!-- 有文件 -->
        <template v-if="filesList.length > 0">
          <el-carousel
            trigger="click"
            class="h100"
            :autoplay="false"
            indicator-position="none"
            :arrow="showArrow"
          >
            <el-carousel-item
              v-for="(item, index) in filesList"
              :key="`file_${index}`"
            >
              <!-- 继续上传 -->
              <template v-if="item && item.type === 1">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  action=""
                  :class="{ 'cursor-not-allowed': isDisabled }"
                  :limit="maxNum"
                  list-type="picture-card"
                  :on-exceed="onExceed"
                  :on-change="onChange"
                  :before-upload="beforeUpload"
                  :on-success="afterUpload"
                  :http-request="fileToWeb"
                  :disabled="isDisabled"
                  :multiple="multiple"
                >
                  <el-button
                    slot="trigger"
                    icon="el-icon-upload"
                    class="upload-text"
                    type="text"
                    v-if="uploadText === '上传图片'"
                  >
                    {{ uploadText }}
                  </el-button>
                  <span slot="trigger" v-else class="upload-show-text">
                    {{ uploadText }}
                  </span>
                  <!-- <div slot="tip" class="el-upload__tip file-tip">
								<p class="text-overflow">当前支持文件格式为: {{ acceptMsg }}</p>
							</div> -->
                </el-upload>
              </template>

              <template v-else>
                <img
                  class="slide-image"
                  :src="
                    item.filePath
                      ? `${uploadUrl}${item.filePath}`
                      : getUrl(item.raw)
                  "
                  alt=""
                />

                <!-- 功能按钮区域 -->
                <div class="btn-tools">
                  <em
                    class="el-icon-zoom-in cursor-pointer"
                    title="查看"
                    @click="handleClick('view', item)"
                  ></em>
                  <em
                    class="ml5 el-icon-download cursor-pointer"
                    title="下载"
                    v-if="!isDisabled"
                    @click="handleClick('download', item)"
                  ></em>
                  <em
                    class="ml5 el-icon-delete cursor-pointer"
                    title="删除"
                    v-if="item.id && !isDisabled"
                    @click="handleClick('delete', item)"
                  ></em>
                </div>
              </template>
            </el-carousel-item>
          </el-carousel>
        </template>

        <!-- 无文件时 -->
        <template v-else>
          <el-upload
            class="upload-demo"
            ref="upload"
            action=""
            :class="{ 'cursor-not-allowed': isDisabled }"
            :limit="maxNum"
            :on-exceed="onExceed"
            :on-change="onChange"
            list-type="picture-card"
            :before-upload="beforeUpload"
            :on-success="afterUpload"
            :http-request="fileToWeb"
            :file-list="filesList"
            :disabled="isDisabled"
            :multiple="multiple"
          >
            <el-button
              slot="trigger"
              icon="el-icon-upload"
              class="upload-text"
              type="text"
              v-if="uploadText === '上传图片'"
              >{{ uploadText }}</el-button
            >
            <span slot="trigger" v-else class="upload-show-text">
              {{ uploadText }}
            </span>
            <!-- <div slot="tip" class="el-upload__tip file-tip">
							<p class="text-overflow">当前支持文件格式为: {{ acceptMsg }}</p>
						</div> -->
          </el-upload>
        </template>
      </template>

      <!-- 列表模式 -->
      <template v-if="listType === 'text'">
        <!-- 文件列表 -->
        <el-upload
          class="upload-demo"
          ref="upload"
          action=""
          :class="{ 'cursor-not-allowed': isDisabled }"
          :limit="maxNum"
          :on-exceed="onExceed"
          :on-change="onChange"
          list-type="text"
          :before-upload="beforeUpload"
          :on-success="afterUpload"
          :http-request="fileToWeb"
          :file-list="filesList"
          :disabled="isDisabled"
          :multiple="multiple"
        >
          <el-button
            slot="trigger"
            icon="el-icon-upload"
            size="small"
            type="text"
            v-if="fileLength < this.maxNum"
          >
            点击上传
          </el-button>

          <div
            slot="tip"
            class="el-upload__tip file-tip"
            v-if="mode !== 'view'"
          >
            <el-tooltip :content="`当前支持文件格式为: ${acceptMsg}`">
              <p class="text-overflow">当前支持文件格式为: {{ acceptMsg }}</p>
            </el-tooltip>
            <p class="text-overflow">
              上传文件大小不超过: {{ fileSize + sizeType }}
            </p>
          </div>
          <div slot="file" class="file-item" slot-scope="{ file }">
            <filename
              :fileName="file.id ? file.fileName : file.name"
              :filePath="file.filePath"
              :fileSize="file.fileSize"
              :showRemove="mode !== 'view' && !isDisabled"
              @doView="handleClick('view', file)"
              @doDelete="handleClick('delete', file)"
            ></filename>
          </div>
        </el-upload>
      </template>
    </template>

    <!-- 查看模式 -->
    <template v-if="isViewMode">
      <!-- 自定义文件列表 -->
      <template v-if="listType === 'text'">
        <div class="view-layout" v-if="viewFilesList.length === 0">
          <div class="empty-style">暂无</div>
        </div>
        <ul class="view-layout" v-else>
          <li
            class="view-list-item"
            v-for="(item, index) in viewFilesList"
            :key="`file_${index}`"
            @click="doView(item)"
          >
            <filename
              :fileName="item.fileName"
              :filePath="item.fileDirectory"
              :downLoad="downLoad"
              @doView="doView(item)"
            ></filename>
          </li>
        </ul>
      </template>

      <!-- 图片模式 -->
      <template v-if="listType === 'picture-card'">
        <el-carousel
          trigger="click"
          class="h100 view-layout"
          :autoplay="false"
          indicator-position="none"
          :arrow="showArrow"
          :style="activeViewStyle"
        >
          <el-carousel-item
            v-for="(item, index) in viewFilesList"
            :key="`file_${index}`"
          >
            <img
              class="slide-image"
              :src="
                item.fileDirectory
                  ? `${uploadUrl}${item.fileDirectory}${item.fileName}`
                  : getUrl(item.raw)
              "
              alt=""
            />
            <!-- 遮罩层 -->
            <div class="view-wrap" :style="activeViewStyle">
              <em
                class="mr5 el-icon-zoom-in cursor-pointer"
                title="查看"
                @click="handleClick('view', item)"
              ></em>
              <em
                class="mr5 el-icon-download cursor-pointer"
                title="下载"
                v-if="item.id"
                @click="handleClick('download', item)"
              ></em>
            </div>
          </el-carousel-item>
          <el-carousel-item
            class="empty-style"
            v-if="viewFilesList.length === 0"
          >
            暂无
          </el-carousel-item>
        </el-carousel>
      </template>
    </template>

    <!-- 图片预览 -->
    <el-dialog
      :visible.sync="dialogObj.visible"
      title="图片预览"
      append-to-body
      top="10vh"
      center
      :width="dialogObj.width"
    >
      <img width="100%" :src="dialogObj.imgUrl" alt="" />
    </el-dialog>

    <!-- 上传进度 -->
    <el-dialog
      title="上传进度"
      width="950px"
      class="progressDialog"
      :visible.sync="progressData.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :append-to-body="true"
    >
      <div class="progress-container">
        <el-row
          v-for="(i, index) in progressData.eventList"
          :key="'eventList' + index"
          class="progress-row"
          :gutter="20"
        >
          <el-col :span="7" class="text-overflow">
            <el-tooltip :content="i.name">
              <span>{{ i.name }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="9">
            <el-progress
              :text-inside="true"
              :stroke-width="24"
              :percentage="i.progress"
            ></el-progress>
          </el-col>
          <el-col :span="8">
            <i class="el-icon-loading mr5" v-show="i.progressLoading"></i>
            {{ i.progressInfo }}
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as Api from "@/api/modules/upload.js";
import { dateFormat } from "utils/tools";

// components
import filename from "./filename";

export default {
  props: {
    // 当前查看模式
    mode: {
      type: String,
      default: "add"
    },
    // 最大文件上传个数
    maxNum: {
      type: Number,
      default: 1
    },
    // 是否支持多选
    multiple: {
      type: Boolean,
      default: true
    },
    // 接收的文件类型
    acceptType: {
      type: Array,
      default: () => {
        return [
          "gif",
          "jpg",
          "jpeg",
          "png",
          "bmp",
          "svg",
          "GIF",
          "JPG",
          "PNG",
          "JPEG",
          "BMP",
          "SVG"
        ];
      }
    },
    // 回显业务表id
    aid: {
      type: String,
      default: ""
    },
    // 业务表名称
    tableName: {
      type: String,
      default: ""
    },
    // assortment
    assortment: {
      type: String,
      default: ""
    },
    // 文件大小
    fileSize: {
      type: Number,
      default: 10 // 10M
    },
    // 文件大小
    sizeType: {
      type: String,
      default: "MB" // 10M
    },
    // 是否可编辑
    isDisabled: {
      type: Boolean,
      default: false
    },
    // 上传文字
    uploadText: {
      type: String,
      default: "上传图片"
    },
    // 宽度
    width: {
      type: String,
      default: "200px"
    },
    // 高度
    height: {
      type: String,
      default: "120px"
    },
    // 是否需要延迟加载
    lazyTime: {
      type: Number,
      default: 0
    },
    // 附件模式 (picture-card 和 text 两种)
    listType: {
      type: String,
      default: "picture-card"
    },
    // 是否为查看模式（只需要图片展示）
    isViewMode: {
      type: Boolean,
      default: false
    },
    // 查看模式文件列表
    viewFilesList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    //是否可以下载
    downLoad: {
      type: Boolean,
      default: false
    },
    // 查看模式动态高度
    viewHeight: {
      type: String,
      default: "120px"
    }
  },
  components: {
    filename
  },
  data() {
    return {
      uploadLoading: false,
      filesList: [],
      addList: [{ type: 1 }],
      addFile: null,
      dialogObj: {
        visible: false,
        width: "900px",
        imgUrl: ""
      },
      // 上传进度条弹窗
      progressData: {
        show: false,
        eventList: []
      },
      progressOverWatch: null,
      // 防抖函数变量
      timeOut: null
    };
  },
  created() {
    this.aid ? this.getFilesList() : "";
  },
  mounted() {
    // let fn = this.fn
    // document.getElementById('input2').addEventListener('input', debounce(fn, 2000))
    // debounce(fn, 1000)
    // 大小调整
    if (this.$refs.fileContainer) {
      this.$refs.fileContainer.style.width = this.width;
      this.$refs.fileContainer.style.height = this.height;
    }
  },
  methods: {
    /*********** 防抖函数 *************/
    debounce(fn, time) {
      // 创建一个标记用来存放定时器的返回值
      let that = this;
      this.timeOut = null;
      let _time = time || 500;

      return (function() {
        // 每当用户输入的时候把前一个 setTimeout clear 掉
        clearTimeout(that.timeout);

        // 然后又创建一个新的 setTimeout, 这样就能保证输入字符后的 interval 间隔内如果还有字符输入的话，就不会执行 fn 函数
        that.timeout = setTimeout(() => {
          fn.apply(this, arguments);
        }, _time);
      })();
    },

    /*********** 文件全流程处理 *************/
    // 工具按钮
    handleClick(type, file) {
      switch (type) {
        case "view":
          // 查看
          if (parseInt(file.size) / 1024 / 1024 > 10) {
            // 大于 10M 无法预览
            this.$message.warning("该附件过大，请下载后预览。");
            return;
          }

          // 非图片模式 无法查看, 直接下载
          if (!this.isPicture(file)) {
            let uploadUrl = process.env.VUE_APP_UPLOAD_URL;
            window.open(
              this.previewUrl +
                this.uploadUrl +
                file.fileDirectory +
                file.fileName,
              "_blank"
            );
            return;
          } else {
            // 预览
            this.dialogObj.imgUrl = file.fileDirectory
              ? this.uploadUrl + file.fileDirectory + file.fileName
              : this.getUrl(file.raw);
            this.dialogObj.visible = true;
          }
          break;
        case "download":
          // 下载
          if (file.id) {
            let _path = file.fileDirectory
              ? file.fileDirectory + file.fileName
              : file.filePath;
            window.open(this.uploadUrl + _path);
          }
          break;
        case "delete":
          // 删除
          if (file.id) {
            let _index = this.filesList.findIndex(x => x.id === file.id);
            this.$confirm("确认要删除当前附件吗?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                Api.deleteFile({ id: file.id })
                  .then(res => {
                    this.$message.success("删除成功!");
                    this.filesList.splice(_index, 1);
                    this.$emit("deleteFileGetDataParams", {fileId: file.id});
                  })
                  .catch(err => {});
              })
              .catch(() => {});
          }
          break;
      }
    },
    // 获取图片地址
    getUrl(file) {
      var url = null;
      if (window.createObjectURL != undefined) {
        url = window.createObjectURL(new Blob(file));
      } else if (window.URL != undefined) {
        url = window.URL.createObjectURL(new Blob(file));
      } else if (window.webkitURL != undefined) {
        url = window.webkitURL.createObjectURL(new Blob(file));
      }
      return url;
    },
    // 获取文件列表
    getFilesList(aid) {
      this.uploadLoading = true;
      this.progressData.eventList = [];
      Api.getFiles({
        aid: !aid ? this.aid : "",
        tableName: this.tableName,
        assortment: this.assortment
      })
        .then(res => {
          this.filesList = res.data;
          setTimeout(() => {
            this.uploadLoading = false;
          }, 500);
        })
        .catch(err => {
          this.filesList = [];
          setTimeout(() => {
            this.uploadLoading = false;
          }, 500);
        });
    },

    // 查看文件
    doView(file) {
      // 非图片模式 无法查看, 直接下载
      if (!this.isPicture(file)) {
        let uploadUrl = "";
        window.open(
          this.previewUrl + this.uploadUrl + file.fileDirectory + file.fileName,
          "_blank"
        );
        return;
      }
      this.dialogObj.imgUrl = file.fileDirectory
        ? this.$uploadUrl + file.fileDirectory + file.fileName
        : this.getUrl(file.raw);
      this.dialogObj.visible = true;
    },

    /*********** 文件上传前的处理 *************/
    // 文件超出个数限制时的钩子
    onExceed() {
      let _existNum = this.filesList.filter(x => x.type !== 1).length;
      let _restNum = this.maxNum - _existNum < 0 ? 0 : this.maxNum - _existNum;

      let _text = `当前已上传 ${_existNum} 个文件， 最多还可上传 ${_restNum} 个文件！`;
      this.$message.warning(_text);
    },
    // 检查文件格式 是否为图片
    isPicture(file) {
      let picArr = ["JPG", "JPEG", "PNG", "GIF", "SVG", "BMP"];
      let fileTypeArr = file.fileName ? file.fileName.split(".") : [];
      let fileType = fileTypeArr[fileTypeArr.length - 1].toUpperCase();

      return picArr.includes(fileType);
    },
    // 文件列表变化事件 --- 判断格式 大小等
    onChange(file, fileList) {
      // console.log(fileList)
      return;
    },
    // 检测所选文件是否符合格式
    checkType(curType) {
      if (this.acceptType.length > 0) {
        if (
          this.acceptType.find(
            x => x === curType || x === curType.toUpperCase()
          )
        ) {
          return true;
        } else {
          this.$message.warning("文件格式不对，请重新选择!");
          return false;
        }
      } else {
        return true;
      }
    },
    // 上传前的判断处理
    beforeUpload(file) {
      let that = this;
      // 检测文件名是否包含非法字符
      let _checkUnicode = true,
        _codeArr = [];
      this.unicodeArr.map(x => {
        if (file.name.includes(x)) {
          _checkUnicode = false;
          _codeArr.push(x);
        }
      });
      if (!_checkUnicode) {
        let _codeStr = _codeArr.join(",");
        this.$message.warning(
          `文件名包含特殊字符，请修改文件名后重新上传。（ 特殊字符：${_codeStr} ）`
        );
        return false;
      }

      // 大小判断
      if (this.sizeType == "MB") {
        if (file.size / 1024 / 1024 > this.fileSize) {
          this.$message.warning(
            `温馨提示：上传图片大小不能超过${this.fileSize} MB`
          );
          return false;
        }
      } else {
        if (file.size / 1024 > this.fileSize) {
          this.$message.warning(
            `温馨提示：当前上传要求图片大小不能超过${this.fileSize} KB`
          );
          return false;
        }
      }

      // 检查格式
      let curType = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (!this.checkType(curType)) {
        return false;
      }

      // 放置添加数组 走单独接口
      let formData = new FormData();
      formData.append("file", file);
      formData.append("path", dateFormat("yyyy-mm-dd"));
      formData.append("output", "json");
      // this.addFile = formData

      // 进度条相关
      let eventFile = {
        file: formData,
        name: file.name
      };
      this.progressData.eventList.push(eventFile);

      return false;
    },

    /*********** 文件上传的处理 *************/
    // 进度条显示处理
    dealProgress(arr) {
      let that = this;
      this.uploadLoading = true;
      // 如果此时选择的文件 + 已有的附件数量 > 设置的最大值  不上传
      let _fileLength = this.filesList.filter(x => x.type !== 1).length;
      let sum = arr.length + _fileLength;

      if (sum > this.maxNum) {
        // this.debounce(this.onExceed, 1000)
        this.onExceed();
        return;
      }

      this.progressData.eventList.map(i => {
        i.progress = 0;
        i.progressLoading = true;
      });

      let fn = function() {
        // 展示进度条弹窗
        that.progressData.show = true;

        // 执行上传
        that.progressData.eventList.map((item, index) => {
          that.fileToWeb(item.file, that.progressFn, index);
        });
      };
      // 防抖限制 500 ms 后执行上传
      this.debounce(fn, 2000);
    },
    // 上传进度函数
    progressFn(progressEvent, index) {
      if (this.progressData.eventList.length > 0) {
        this.progressData.eventList[index].progress =
          (progressEvent.loaded / progressEvent.total) * 100 || 0;
        if (this.progressData.eventList[index].progress === 100) {
          this.progressData.eventList[index].progressInfo =
            "正在合并文件并等待服务器回应, 请稍后....";
        } else {
          this.progressData.eventList[index].progressInfo = "正在上传";
        }

        // let data = this.progressData.eventList[index]
        // console.log(data)
        // this.$set(this.progressData.eventList, index, data)
      }
    },
    // 上传服务器
    fileToWeb(file, progressFn, index) {
      Api.uploadToWebNew(file, progressFn, index)
        .then(res => {
          // console.log(res)
          res.data.filePath = res.data.path;
          this.filesList.push(res.data);
          this.addFile = null;
          this.$emit("getDataParams", res);
          // 上传本地数据库
          this.fileToLocal(this.aid, res.data, index);
        })
        .catch(err => {
          this.addFile = null;
        });
    },
    // 文件上传方法 --- 上传数据库
    fileToLocal(uploadId, params, index) {
      // 在有上传数据的情况下
      let _aid = uploadId;
      let that = this;

      let dataParams = {
        path: params.path,
        md5: params.md5,
        size: params.size,
        aid: _aid,
        tableName: this.tableName,
        assortment: this.assortment
      };

      setTimeout(() => {
        Api.saveFile(dataParams)
          .then(res => {
            // 进度条更新
            this.$set(this.progressData.eventList, index, {
              progressInfo: "上传成功",
              progressLoading: false,
              progress: 100,
              name: this.progressData.eventList[index].name
            });
            this.$emit("saveFileGetDataParams", {...params,aid: _aid,
              tableName: this.tableName,
              assortment: this.assortment});
            // 刷新
            // this.debounce(this.backSuccess, 1000)
          })
          .catch(err => {
            // 进度条更新
            if (this.progressData.eventList.length > 0) {
              this.$set(this.progressData.eventList, index, {
                progressInfo: "上传失败, 请关闭后重试",
                progressLoading: false,
                progress: 0,
                name: this.progressData.eventList[index].name
              });
              // 重新渲染
              // this.debounce(this.backError, 1000)
            }
          });
      }, this.lazyTime);
    },

    /*********** 文件上传后的处理 *************/
    // 上传完成后的回调 --- 当前方式未触发
    afterUpload(response, file, fileList) {
      // console.log('afterUpload:' + response)
    },
    // 成功回调
    backSuccess() {
      // 重新渲染
      this.getFilesList();
      // 回调
      this.$emit("on-success");
    },
    // 失败回调
    backError() {
      this.$message.error("附件上传数据库失败！");
      // 重新渲染
      this.getFilesList();
      // 回调
      this.$emit("on-error");
    }
  },
  computed: {
    // 当前文件列表数量
    fileLength() {
      return this.filesList.filter(x => x.type !== 1).length;
    },

    // 非法字符集
    unicodeArr() {
      return ["`", "~", "!", "@", "#", "$", "%", "^", "&", "+", ";", " "];
    },

    // 支持的文件格式 文字
    acceptMsg() {
      return this.acceptType.length > 0
        ? JSON.stringify(this.acceptType)
        : "所有格式文件";
    },

    // 上传接口地址
    uploadUrl() {
      return process.env.VUE_APP_UPLOAD_URL;
    },

    // 预览环境变量
    previewUrl() {
      return process.env.VUE_APP_PREVIEW_URL;
    },

    // 是否显示切换箭头
    showArrow() {
      return this.filesList.length <= 1 ? "never" : "hover";
    },

    // 查看模式 --- 动态样式
    activeViewStyle() {
      return {
        height: this.viewHeight,
        lineHeight: this.viewHeight
      };
    }
  },
  watch: {
    // 文件列表
    filesList(arr) {
      let _exist = arr.find(x => x.type === 1);
      if (
        arr.length < this.maxNum &&
        !_exist &&
        this.listType === "picture-card"
      ) {
        this.filesList.push({ type: 1 });
      }
    },

    // 待上传progress 列表
    "progressData.eventList": {
      handler: function(arr) {
        if (arr.length > 0 && !this.uploadLoading) {
          this.dealProgress(arr);
        }

        if (arr.length === 0) {
          this.progressData.show = false;
        }

        // 全部上传完毕（包括成功失败）
        if (
          arr.filter(x => !x.progressLoading).length === arr.length &&
          arr.length !== 0
        ) {
          this.debounce(this.backSuccess, 1000);
        }
      },
      deep: true
    },

    // 监听主键id 变化
    aid(val) {
      if (val !== "") {
        setTimeout(() => {
          this.getFilesList();
        }, this.lazyTime);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.file-container {
  // min-width: 200px;
  // min-height: 120px;
  width: 100%;
  height: 100%;
  position: relative;

  /deep/ .el-carousel__container {
    height: 100%;

    img {
      height: 100%;
      width: 100%;
      transition: all 1s ease;
    }
  }

  .btn-tools {
    position: absolute;
    right: 0;
    top: 0;
    background-color: #2d2d2d6e;
    height: 30px;
    line-height: 30px;
    padding: 0 8px;
    color: #fff;
  }

  &:hover img {
    transform: scale(1.2);
  }
}

.upload-demo {
  height: 100%;
  color: #666;
  font-size: 14px;

  /deep/ .file-tip {
    font-size: 12px;
    margin-top: 0;
    height: 30px;
    line-height: 30px;
  }

  /deep/ .el-upload {
    width: 100%;
    height: 100%;
  }

  .upload-text {
    vertical-align: text-bottom;
    display: inline-block;

    /deep/ span {
      margin-top: -11px;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .upload-show-text {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.list-upload {
  .upload-demo {
    display: flex;
    flex-direction: column;
  }

  /deep/ .el-upload {
    width: auto;
    height: auto;
    text-align: left;
  }

  /deep/ .file-tip {
    height: auto;
    line-height: 24px;
    padding-top: 4px;
  }

  /deep/ .el-upload-list__item {
    margin-top: 0;
    line-height: 30px;
  }
}

/******* 竖直模式下的文字显示 ******/
.column-layout {
  .upload-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    vertical-align: unset;
    width: 100%;
    padding: 0;

    /deep/ span {
      margin-top: 5px;
    }
  }
}

.cursor-not-allowed {
  /deep/ .el-upload {
    cursor: not-allowed;
  }

  /deep/ .upload-text {
    cursor: not-allowed;
  }

  /deep/ .el-button--text {
    cursor: not-allowed;
  }
}

// **********  查看模式样式  ********* //
.view-layout {
  min-height: 120px;

  /deep/ .el-carousel__container {
    height: 100%;
    min-height: 120px;

    img {
      height: 100%;
      width: 100%;
      transition: all 1s ease;
    }
  }

  .empty-style {
    border: 1px dashed #c0ccda !important;
    background-color: #fbfdff;
    text-align: center;
    line-height: 120px;
    color: #666;
    border-radius: 5px;
  }

  .view-list-item {
    line-height: 24px;
    font-size: 14px;
    // color: #2671cc;
  }

  /deep/ .el-dropdown {
    color: #2671cc;
  }

  &:hover .view-wrap {
    display: block;
  }
}

.view-wrap {
  display: none;
  width: 100%;
  height: 100%;
  min-height: 120px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: #ededed;
  text-align: center;
  font-size: 20px;
}

// ******* 上传进度条样式 ******** //
.progress-container {
  .progress-row {
    display: flex;
    align-items: center;
    line-height: 40px;
  }
}
</style>
